import { render, staticRenderFns } from "./Pod.vue?vue&type=template&id=f913e90c&scoped=true&"
import script from "./Pod.vue?vue&type=script&lang=ts&"
export * from "./Pod.vue?vue&type=script&lang=ts&"
import style0 from "./Pod.vue?vue&type=style&index=0&id=f913e90c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f913e90c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
